import JwtService from "@/core/services/jwt.service";
import store from "../core/services/store";
import { LOGOUT } from "@/core/services/store/auth.module";

export default {
  onBeforeSend: (method, ajaxOptions) => {
    var pharmacy = store.getters["currentPharmacy"];
    ajaxOptions.headers = {
      authorization: `Bearer ${JwtService.getToken()}`,
      PharmacyGuid: pharmacy.guid,
      ApplicationGuid: `08492cdb-dadf-4f96-8082-004d1acbe8f9`,
      "Accept-Language": "fr"
    };

  },
  onAjaxError: function(e) {
    if (e.xhr.status == 401) {
      store.dispatch(LOGOUT);
    }
  },
};
